import React, { useContext } from "react";
import { JokerBansContext } from "./context";
import BanSelection from "../BanSelection";

type JokerBansType = {
  badgeQuantity?: number;
  whoBan?: "player1" | "player2";
  soloSide?: "Player 1" | "Player 2";
};

const JokerBans = (props: JokerBansType) => {
  const { badgeQuantity = 0, whoBan = "player1", soloSide } = props;
  const { dispatch, selectingBans, selectedBansPlayer1, selectedBansPlayer2 } =
    useContext(JokerBansContext);

  return (
    <BanSelection
      badgeQuantity={badgeQuantity}
      whoBan={whoBan}
      soloSide={soloSide}
      showEvent="show-joker-bans"
      clickEvent="on-click-show-joker-bans"
      selectedEvent="selected-joker-ban"
      sendEvent="send-joker-ban"
      buttonText={"Bans joker"}
      dispatch={dispatch}
      selectingBans={selectingBans}
      selectedBansPlayer1={selectedBansPlayer1}
      selectedBansPlayer2={selectedBansPlayer2}
      roomUpdate={(room, dispatchRoom) => {
        dispatchRoom({
          jokerBansPlayer1: room.jokerBansPlayer1 ?? undefined,
          jokerBansPlayer2: room.jokerBansPlayer2 ?? undefined,
        });
      }}
      selectedUpdate={(chars, role, dispatch) => {
        if (role === "Player 1") dispatch({ selectedBansPlayer1: chars });
        else dispatch({ selectedBansPlayer2: chars });
      }}
    />
  );
};

export default JokerBans;
